/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField, DropdownSelectField, DateField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import metadata from './PriorProjectComponent.metadata.json5';
import styles from './PriorProjectComponent.module.scss';
import { TranslatorContext } from '@jutro/legacy/locale';

function PriorProjectComponent(props) {

    const {
        data: PriorProjectVM,
        updateWizardData,
        submissionVM,
        PriorProjectPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);

    const translator = useContext(TranslatorContext);


    const addPriorProject = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            PriorProjectVM.value = PriorProjectVM.value || []

            const { _xCenter, _dtoName } = PriorProjectVM;

            const PriorProjectObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            PriorProjectObjVM.value.valFie = 0

            PriorProjectVM.pushElement(
                PriorProjectObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, PriorProjectVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            PriorProjectVM.value.splice(index, 1);
            _.set(submissionVM.value, PriorProjectPath, PriorProjectVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, PriorProjectPath, PriorProjectVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'namFie') {
                const value = item.namFie ? item.namFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.namFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'typFie') {
                const value = (item && item.typFie) ? item.typFie : undefined;

                // eslint-disable-next-line security/detect-object-injection
                const availableValues = PriorProjectVM.length > 0 && PriorProjectVM.children[index].typFie
                    // eslint-disable-next-line security/detect-object-injection
                    ? PriorProjectVM.children[index].typFie.aspects.availableValues
                        .map((typeCode) => ({
                           code: typeCode.code,
                           name: translator({
                            id: typeCode.name,
                            defaultMessage: typeCode.name
                           }) 
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.typFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        path={path}
                        dataType="string"
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'locFie') {
                const value = item.locFie ? item.locFie : '';
            
                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.locFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'valFie') {
                const value = item.valFie;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.valFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'datComFie') {
                const value = item.datComFie ? item.datComFie : '';
            
                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        onValueChange={(val, changedPath) => {
                            item.datComFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

            if (path === 'desFie' && !_.isUndefined(item.typFie) && item.typFie === 'Oth') {
                const value = item.desFie ? item.desFie : '';
            
                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [PriorProjectVM, handleValueChange, translator])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`PriorProjectTable`]: {
            data: PriorProjectVM.value,
        }

    }), [PriorProjectVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addPriorProject,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            PriorProjectVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [PriorProjectVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={PriorProjectVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PriorProjectComponent.propTypes = wizardProps;
export default withRouter(PriorProjectComponent);
